import React from 'react';

import styled from 'styled-components';

import IconAmex from 'components/icons/amex';
import IconDiscover from 'components/icons/discover';
import IconMastercard from 'components/icons/mastercard';
import IconVisa from 'components/icons/visa';

import { ICreditCardFormTitle } from './credit-card-form-title.types';

const Container = styled.div`
  padding-bottom: 1rem;
`;
const Title = styled.p`
  line-height: 1.5rem;
  margin: 0px;
  padding-bottom: 0.5rem;
`;
const CardContainer = styled.div`
  color: ${Styles.color.grey.three};
  display: flex;
  align-items: center;

  svg {
    height: 1.6rem;
    fill: ${Styles.color.grey.three};
    padding-right: 0.25rem;
  }
`;
const CreditText = styled.span`
  padding-right: 0.75rem;
`;

const FormTitle = ({ title, creditText }: ICreditCardFormTitle) => (
  <Container>
    <Title>{title}</Title>
    <CardContainer>
      <CreditText>{creditText}</CreditText>
      <IconVisa />
      <IconMastercard />
      <IconAmex />
      <IconDiscover />
    </CardContainer>
  </Container>
);

export default FormTitle;
